export default __webpack_public_path__ + "static/media/arrow-left.6cde0c15.svg";